var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('img',{staticClass:"page-header__logo",attrs:{"alt":"","src":require("@/assets/images/home/logo.png")},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }